export const TIME_ENTRIES_QUERY_KEY = ['timeEntries']
export const PROJECTS_QUERY_KEY = ['projects']
export const ASSIGNMENTS_QUERY_KEY = ['assignments']
export const TIMESHEETS_QUERY_KEY = ['timesheets']
export const TIME_OFF_ENTRIES_QUERY_KEY = ['timeOffEntries']
export const TIME_OFF_CODES_QUERY_KEY = ['timeOffCodes']
export const OUTLOOK_EVENTS_QUERY_KEY = ['outlookEvents']
export const OUTLOOK_EMAILS_QUERY_KEY = ['outlookEmails']
export const UNHANDLED_ENTRIES_QUERY_KEY = ['unhandledEntries']
export const PROJECT_OVERVIEW_QUERY_KEY = ['projectOverview']
export const USER_SETTINGS_QUERY_KEY = ['userSettings']
export const REMINDER_SETTINGS_QUERY_KEY = ['reminderSettings']
export const DELEGATE_ACCESS_QUERY_KEY = ['delegateAccess']
